/**
 * 1) `.js-lbp-scroll-to-section` (LPB banner button) — scrolls to `data-lbp-scroll-target` when set,
 *    otherwise `.category-filter-section` (SEM landing pages) or `.main-compare-wrapper`.
 *    Uses offsetTop - 60 like custom-page-banner.
 * 2) `[data-landing-compare-go]` — persist `selectedIds` from active listing rows / checkboxes, then navigate.
 */
(function () {
  "use strict";
  if (window.__landingCompareNavigateBound) return;
  window.__landingCompareNavigateBound = true;

  var STORAGE_KEY = "selectedIds";
  var DEFAULT_DEST = "/pages/compare";
  /** Same offset as `sections/custom-page-banner.liquid` scroll-to-section */
  var SCROLL_TOP_OFFSET = 60;
  var LPB_SCROLL_BTN_SELECTOR = ".js-lbp-scroll-to-section, .js-lbp-scroll-to-category-filter";

  function scrollLpbToTarget(btn) {
    var targetId = btn && btn.getAttribute("data-lbp-scroll-target");
    var targetSection = targetId
      ? document.getElementById(targetId)
      : document.querySelector(".category-filter-section") ||
        document.querySelector(".main-compare-wrapper");
    if (!targetSection) return;
    var offsetTop = targetSection.offsetTop - SCROLL_TOP_OFFSET;
    window.scrollTo({
      top: Math.max(0, offsetTop),
      behavior: "smooth",
    });
  }

  function handlesFromActiveListingRows() {
    var out = [];
    var seen = Object.create(null);
    document.querySelectorAll(".page-listings .page-listings-inner.active").forEach(function (row) {
      var h = row.getAttribute("data-handle");
      if (h && !seen[h]) {
        seen[h] = true;
        out.push(h);
      }
    });
    return out;
  }

  function handlesFromCompareCheckboxes() {
    var out = [];
    var seen = Object.create(null);
    document.querySelectorAll("input.compare-checkbox[data-handle]").forEach(function (checkbox) {
      checkbox.checked = true;
      var h = checkbox.getAttribute("data-handle");
      if (h && !seen[h]) {
        seen[h] = true;
        out.push(h);
      }
    });
    return out;
  }

  function persistLandingCompareSelectionAndNavigate(destinationHref) {
    var dest = destinationHref && String(destinationHref).trim();
    if (!dest || dest === "#") dest = DEFAULT_DEST;

    var handles = handlesFromActiveListingRows();
    if (handles.length < 1) {
      handles = handlesFromCompareCheckboxes();
    }

    if (handles.length > 0) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
      } catch (e) {
        /* ignore */
      }
    }

    window.location.href = dest;
  }

  window.persistLandingCompareSelectionAndNavigate = persistLandingCompareSelectionAndNavigate;

  document.addEventListener("click", function (e) {
    var lpbBtn = e.target.closest(LPB_SCROLL_BTN_SELECTOR);
    if (lpbBtn) {
      e.preventDefault();
      scrollLpbToTarget(lpbBtn);
      return;
    }

    var goBtn = e.target.closest("[data-landing-compare-go]");
    if (!goBtn) return;
    e.preventDefault();
    var dest =
      goBtn.getAttribute("data-compare-destination") ||
      goBtn.getAttribute("href") ||
      DEFAULT_DEST;
    persistLandingCompareSelectionAndNavigate(dest);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var lpbBtn = e.target.closest(LPB_SCROLL_BTN_SELECTOR);
    if (!lpbBtn) return;
    e.preventDefault();
    scrollLpbToTarget(lpbBtn);
  });
})();
